__turbopack_context__.v({
  "body": "ToggleMenu-module__OPXD8G__body",
  "selected": "ToggleMenu-module__OPXD8G__selected",
  "title": "ToggleMenu-module__OPXD8G__title",
  "titleOptions": "ToggleMenu-module__OPXD8G__titleOptions",
  "toggleMenu": "ToggleMenu-module__OPXD8G__toggleMenu",
});
